<template>
  <div class="bg-coral-100 p-4 text-center flex flex-col flex-grow justify-between h-100 mb-4">
    <div class="text-4xl text-bold font-montserrat flex items-center justify-center flex-shrink-0">
      <span class="text-2xl mr-1">{{ counter.prefix }}</span> {{ counter.value }}
    </div>
    <div class="text-sm leading-tight tracking-tight uppercase" v-text="counter.name"></div>
  </div>
</template>

<script>
export default {
  name: 'DashboardCounter',
  props: {
    counter: {
      type: Object,
    },
  },
};
</script>
